import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon-black.svg";

const RolandGarrosInfo = ({ onClose }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <h2>ROLAND-GARROS</h2>
            <p>127 years of history</p>
            <p>
              <b>Roland-Garros</b> is one of tennis’s four Grand Slam
              tournaments and the premier clay-court event. Held annually in{" "}
              <b>Paris</b>, it combines the elegance of the city with the
              grueling demands of the red clay, where long rallies and mental
              endurance crown true champions.
            </p>
            <p>
              The tournament is named after <b>Roland Garros</b>, a French
              aviator and WWI hero. It began in 1891 and became international in
              1925.
            </p>
            <p>
              The current <b>Stade Roland-Garros</b> opened in 1928, shortly
              after French legends known as <b>“The Four Musketeers”</b> brought
              glory to the nation.
            </p>
            <p>
              Over the years, it has <b>hosted legendary moments</b>: Björn
              Borg’s dominance in the '70s, Andre Agassi’s emotional 1999 win,
              and Rafael Nadal’s record-setting 14 titles. Known for its
              unpredictable bounce and physical demands,{" "}
              <b>
                Roland-Garros is a blend of sport, style, and tradition—uniquely
                Parisian.
              </b>
            </p>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default RolandGarrosInfo;
